export default "__VITE_ASSET__CsREqh3J__"